import { findDistrictByShortCode, getDistrictLocaleKey, sortDistricts } from '../../libs/mapping/district'
import { findJobTypeByShortCode, sortJobTypes, translateJobTypeWithFallback } from '../../libs/mapping/jobType'

export default {
  methods: {
    /**
     * Get a label of district names
     * based on provided district IDs
     * @param {[string]} districtIDs
     * @returns {string}
     */
    getDisplayDistrictsLabel(districtIDs) {
      // Map district IDs into district data,
      // sort, then map into localised label
      if (Array.isArray(districtIDs) && districtIDs.length) {
        return sortDistricts(districtIDs.map(findDistrictByShortCode))
          .map((district) => this.$t(getDistrictLocaleKey(district)))
          .filter((l) => l)
          .join(this.$t('general.comma'))
      }
      return ''
    },

    /**
     * Get a label of job type names
     * based on provided job type short code
     * @param {[string]} jobTypeShortCodes
     * @returns {string}
     */
    getDisplayJobTypesLabel(jobTypeShortCodes) {
      // Map job type IDs into job type data,
      // sort, then map into localised label
      if (Array.isArray(jobTypeShortCodes) && jobTypeShortCodes.length) {
        // Need to inject "this" context to i18n callbacks,
        // ref: https://kazupon.github.io/vue-i18n/api/#vue-injected-methods
        return sortJobTypes(jobTypeShortCodes.map(findJobTypeByShortCode))
          .map((jobType) => translateJobTypeWithFallback(jobType, this.$te.bind(this), this.$t.bind(this)))
          .filter((l) => l)
          .join(this.$t('general.comma'))
      }
      return ''
    },
  },
}
